<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <router-link :to="{path:'/jiejue'}" tag="li">商会后台</router-link>
            <router-link :to="{path:'/fuwushang'}" tag="li">卖家中心</router-link>
            <router-link :to="{path:'/zhengfu'}" tag="li">政府机构</router-link>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <!-- 内容 -->
    <div class="content">
      <img src="../../assets/img/jieju/fws_settled in_banner.png" alt />
    </div>
    <div class="content1_1">
      <div class="content1">
        <div class="content1_one">
          <img src="../../assets/img/jieju/fws_settled in_step02.png" alt />
        </div>
        <div class="conetent_cent">
          <div class="conetent_cent_1">
            <div class="conetent_cent_one">
              <p>公司名称：</p>
              <div class="conetent_cent_name">{{this.providerss}}</div>
            </div>
            <div class="conetent_cent_two">
              <p>LOGO：</p>
              <el-form :model="article" label-width="120px">
                <el-form-item label style="width: 1000px;" prop="image">
                  <template>
                    <el-upload
                      :action="upImgUrl"
                      list-type="picture-card"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove"
                      :on-success="handleAvatarSuccess"
                      :on-exceed="handleExceed"
                      :limit="1"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="imgPath + article.image" alt />
                    </el-dialog>
                  </template>
                </el-form-item>
              </el-form>
            </div>
            <div class="conetent_cent_one">
              <p>
                <span style="color:#FF4D43">*</span>公司简介：
              </p>
              <el-input
                type="textarea"
                :rows="2"
                placeholder="选择服务类目"
                v-model="form_settl.content"
                class="input3"
              ></el-input>
            </div>
            <div class="conetent_cent_one">
              <p>
                <span style="color:#FF4D43">*</span>公司规模：
              </p>
              <el-select placeholder="选择公司规模" v-model="form_settl.enterprise_scale" class="input2">
                <el-option
                  v-for="item in optionss"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  style="width:335px"
                ></el-option>
              </el-select>
            </div>
            <div class="conetent_cent_one">
              <p>
                <span style="color:#FF4D43">*</span>服务区域：
              </p>
              <el-form>
                <el-form-item class="pr">
                  <el-cascader
                    :options="options"
                    :props="defaultParams1"
                    v-model="form_settl.office_address_province_id"
                    @change="handleChange"
                    ref="cascaderAddr"
                    style="width:335px"
                    :show-all-levels="false"
                    filterable
                  ></el-cascader>
                </el-form-item>
              </el-form>
            </div>
            <div class="conetent_cent_three_1">
              <div class="conetent_cent_three" v-for="(item,index) in lists1" :key="index">
                <p>服务类目：</p>
                <el-form>
                  <el-form-item class="pr">
                    <el-cascader
                      :options="options_one"
                      :props="defaultParams2"
                      v-model="lists1[index][0].content"
                      @change="handleChange"
                      ref="cascaderAddr"
                      style="width:335px;margin-top:20px"
                    ></el-cascader>
                  </el-form-item>
                </el-form>
                <div class="conetent_cent_two">
                  <p>上传资质：</p>
                  <el-form :model="article" label-width="120px">
                    <el-form-item label style="width: 1000px;" prop="image">
                      <template>
                        <el-upload
                          :action="upImgUrl_one"
                          list-type="picture-card"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="handleRemove"
                          :on-success="handleAvatarSuccess"
                          :on-exceed="handleExceed"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible">
                          <img width="100%" :src="imgPath  + article.image" alt />
                        </el-dialog>
                      </template>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="content_moban_bottom_1" @click="addlistdel(index)">
                  <img src="../../assets/img/dingdan/fws_btn_del_nor.png" alt />
                </div>
              </div>
              <div class="content_moban_bottom" @click="addlist()">
                <img src="../../assets/img/dingdan/fws_btn_add service_nor.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="content_floor" @click="idem()">
          <a href="#">下一步</a>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li>
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoginphone, getRegionList } from "@/http/api";
import VueNeditorWrap from "vue-neditor-wrap";
import editor from "@/config/editor";
import config from "@/config/index";
export default {
  components: {
    VueNeditorWrap
  },
  data() {
    return {
      from: {
        ecord: "",
        phone: "",
        address: "",
        introduction: "",
        name: "",
        providers_name: "",
        office_address_province_id: ""
      },
      TIME_COUNT: 60, //验证码倒计时60s
      show: true,
      cang: false,
      count: "",
      options: [],
      defaultParams: {
        label: "name",
        children: "children"
      },
      defaultParams1: {
        label: "region",
        value: "id",
        children: "brands"
      },
      defaultParams2: {
        label: "category_name",
        value: "id",
        children: "list"
      },
      upImgUrl: config.api + "/Goods/uploadHeaderImage",
      imgPath: config.apiPath,
      upImgUrl_one: config.api + "/Goods/uploadImage",
      imgPath_one: config.apiPath,
      article: {
        image: ""
      },
      optionss: [
        {
          value: "0-20人",
          label: "0-20人"
        },
        {
          value: "21-100人",
          label: "21-100人"
        },
        {
          value: "101-500人",
          label: "101-500人"
        },
        {
          value: "501-1000人",
          label: "501-1000人"
        },
        {
          value: "1000人以上",
          label: "1000人以上"
        }
      ],
      dialogVisible: false,
      lists1: [
        [
          { title: "服务类目：", content: "", name: "name", type: "input" },
          { title: "上传资质：", content: "", name: "content", type: "input" }
        ]
      ],
      form_settl: {
        content: "",
        enterprise_scale: ""
      },
      options_one: [],
      url: ""
    };
  },
  methods: {
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    },
    getCode(from) {
      if (!/^1[34578]\d{9}$/.test(this.from.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.from.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.from.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    getRegion() {
      this.$http(
        "https://coc.sqifu.com/Api/City/getCityList",
        {},
        "post"
      ).then(res => {
        this.options = res.data.data;
      });
    },
    handleChange(value) {
      console.log(value);
      let labels = this.$refs["cascaderAddr"].currentLables;
      console.log(this.$refs["cascaderAddr"]);
    },
    handleRemove(file, fileList) {
      this.article.image = "";
    },
    handlePictureCardPreview(file) {
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      console.log(file);
      this.article.image = res.data;
      console.log(res.data);
      this.url = res.data.url;
    },
    handleExceed(files, fileList) {
      this.$message.error("只能上传四张图片！");
    },
    addlist() {
      console.log(this.lists1);
      const list = [
        { title: "服务类目：", content: "", name: "name", type: "input" },
        { title: "上传资质：", content: "", name: "content", type: "input" }
      ];
      this.lists1.push(list);
    },
    //删除
    addlistdel(index) {
      console.log(index);
      if (index != 0) {
        this.lists1.splice(index, 1);
      }
    },
    idem(url) {
      var providers = this.$route.params.providers_name;
      var phone = this.$route.params.phone;
      var name = this.$route.params.name;
      var office_address_province_id = this.$route.params
        .office_address_province_id;
      var address = this.$route.params.address;
      var introduction = this.$route.params.introduction;
      this.$http(
        "https://ctapi.sqifu.com/api/v1/createManagement_Provider",
        {
          name: name,
          avatar: this.url,
          city_id: 1,
          providers_name: providers,
          office_address_province_id: office_address_province_id,
          address: address,
          introduction: introduction,
          content: this.form_settl.content,
          enterprise_scale: this.form_settl.content,
          phone: phone
        },
        "post"
      ).then(res => {
        if (res.data.stateCode === 200) {
          this.$http(
            "https://ctapi.sqifu.com/api/v1/getProviderCategoryApplyList",
            {
              provider_id: res.data.data.id
            },
            "post"
          ).then(res => {
            if (res.data.stateCode === 200) {
                this.$router.push({
                  name: "settledtwo"
                });
            }
          });
        }
      });
    },
    applyList() {
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getProviderCategoryApplyList",
        {},
        "post"
      ).then(res => {
        this.options_one = res.data.data;
      });
    }
  },
  created() {
    this.getRegion();
    this.applyList();
    this.providerss = this.$route.params.providers_name;
    console.log( this.providerss);
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

/* 内容 */

.content {
  width: 100%;
  height: auto;
  background: #000;
}

.content img {
  margin-left: 214px;
}

.content1_1 {
  width: 100%;
  height: auto;
  background: #f4f5f9;
  overflow: hidden;
}

.content1 {
  width: 940px;
  height: auto;
  margin: 20px auto;
  background: #fff;
  overflow: hidden;
}

.content1_one {
  width: 750px;
  height: 49px;
  margin: 30px auto;
}

.conetent_cent {
  width: 608px;
  margin: 10px 0 0 180px;
}

.conetent_cent_name {
  font-size: 14px;
  line-height: 36px;
}

.conetent_cent_two {
  width: 100%;
  height: 150px;
  margin-bottom: 34px;
}

.conetent_cent_four {
  width: 100%;
  height: 148px;
  margin-bottom: 34px;
}

.conetent_cent_four p {
  width: 80px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_four span {
  margin-right: 5px;
}

.conetent_cent_two p {
  width: 80px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_two span {
  margin-right: 5px;
}

.conetent_cent_three {
  width: 100%;
  height: 254px;
  margin-bottom: 24px;
  background: #f4f5f9;
  position: relative;
}

.conetent_cent_three p {
  width: 84px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
  margin-top: 20px;
}

.conetent_cent_three span {
  margin-right: 5px;
}

.content_floor {
  width: 260px;
  height: 44px;
  background: #007bff;
  border-radius: 5px;
  text-align: center;
  margin: 0 auto;
}

.content_floor a {
  color: #fff;
  line-height: 44px;
}

.input {
  width: 699px;
}
.input2 {
  width: 336px;
}
.input3 {
  width: 336px;
}

.input1 {
  width: 336px;
  height: 66px;
}

.conetent_cent_one {
  width: 100%;
  height: 36px;
  margin-bottom: 34px;
}

.conetent_cent_one p {
  width: 84px;
  font-size: 14px;
  color: #666666;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
}

.conetent_cent_one span {
  margin-right: 5px;
}

.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  width: 458px;
  margin-bottom: 20px;
}

.content_moban_bottom_1 img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 10px;
  right: 20px;
}

.conetent_cent_three_1 {
  width: 100%;
  height: auto;
}

.content_moban_bottom {
  width: 608px;
  height: 70px;
  margin: 0 auto;
}

.content_moban_bottom img {
  width: 126px;
  height: 32px;
  margin-left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/view/jiejue/Settledone.vue